import React from 'react';
import dollarFormat from '../../dollar-format';
import request from 'arcdynamic-request';
import LinkComp from '../LinkComp';
import {PROPERTIES} from '../../consts/tables';
import Dropdown from '../Dropdown/Dropdown';

function percent(value) {
    if (value === undefined || value === null || value === '') return '';
    return Number(value).toFixed(2) + '%';
}

export default class StatsColumn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null,
            isBusy: null,
            type: '',
        };

        this._setType = this._setType.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    _setType(e) {
        this.setState({type: e.target.value});
    }

    fetch(source, type) {
        this.setState({isBusy: true});

        const filter = [{
            code: 'STATUS',
            text: this.props.status,
            type: 'exact',
        }];

        if (this.props.status === 'Closed') {
            filter.push({
                code: 'SOLD_PRICE',
                text: '',
                type: 'notNull',
            }, {
                code: 'CLOSE_CAP_RATE',
                text: '',
                type: 'notNull',
            });
        } else {
            filter.push({
                code: 'LIST_PRICE',
                text: '',
                type: 'notNull',
            }, {
                code: 'CAPITALIZATION_RATE',
                text: '',
                type: 'notNull',
            });

            if (source === 'STRIVE')
                filter.push({
                    code: 'FEATURED',
                    text: 'y',
                    type: 'exact',
                });
        }

        if (source)
            filter.push({
                code: 'SOURCE',
                text: source,
                type: 'exact',
            });

        if (type)
            filter.push({
                code: 'TYPE',
                text: type,
                type: 'exact',
            });

        request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', PROPERTIES, {
                limit: {
                    count: 10,
                    offset: 0,
                },
                filter,
                filterType: 'and',
                order: [{
                    code: this.props.order,
                    type: 'desc',
                }],
            }],
        }).then((res) => {
            if (res && res.success) {
                this.setState({
                    items: res.data,
                    isBusy: null,
                });
            } else {
                this.setState({
                    items: false,
                    isBusy: null,
                });
            }
        });
    }

    handleChangeDropdown(query, queryType, x, key) {
        this.setState({type: query[key]});
    }

    componentDidMount() {
        this.fetch(this.props.source, this.state.type);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.source !== this.props.source || prevState.type !== this.state.type)
            this.fetch(this.props.source, this.state.type);
    }

    render() {
        const mapQuery = {};
        {
            const d = new Date();
            d.setUTCFullYear(d.getUTCFullYear() - 1);
            mapQuery.CLOSE_OF_ESCROW_MIN = `${
            d.getUTCMonth() + 1
                }/${d.getUTCDate()}/${d.getUTCFullYear()}`;
        }

        const query = {
            TYPE: this.state.type,
            STATUS: this.props.status,
            SOURCE: this.props.source,
            order: this.props.order + '.desc',
        };

        return (
            <div className='StatsColumn' data-is-busy={this.state.isBusy}>
                {this.state.items ? (
                    <div className='table-container last'>
                        <div className='table-head'>
                            <div className='stats-title'>Recently {this.props.keyword}</div>
                            <Dropdown className='stats-dropdown'
                                      optionsType='type'
                                      value={this.state.type}
                                      valueKey='type'
                                      handleParentChange={this.handleChangeDropdown}
                                      placeholder='TYPE'
                                      optionKey='code'
                                      optionLabelKey='name'
                            />
                        </div>
                        <table className='stats-table'>
                            <thead/>
                            <tbody>
                            {this.state.items.map((el) => (
                                <tr key={el.ARCIMEDES_ROW_ID}>
                                    <td>{el.TYPE || 'N/A'}</td>
                                    <td className='stats-table-name'>
                                        {this.props.status === 'Active' ? (
                                            <a
                                                href={`https://strivere.com/property/${el.ARCIMEDES_ROW_ID}`}
                                                target='_blank'
                                            >
                                                {el.NAME || 'N/A'}
                                            </a>
                                        ) : (
                                            <LinkComp to={{pathname: 'map', query: mapQuery}}>
                                                {el.NAME || 'N/A'}
                                            </LinkComp>
                                        )}
                                    </td>
                                    <td>{el.CITY || 'N/A'}</td>
                                    <td>{el.STATE || 'N/A'}</td>
                                    <td style={{textAlign: 'right'}}>
                                        {this.props.status === 'Active'
                                            ? el.LIST_PRICE
                                                ? dollarFormat(el.LIST_PRICE)
                                                : 'N/A'
                                            : el.SOLD_PRICE
                                                ? dollarFormat(el.SOLD_PRICE)
                                                : 'N/A'}
                                    </td>
                                    <td style={{textAlign: 'right'}}>
                                        {this.props.status === 'Active'
                                            ? el.CAPITALIZATION_RATE
                                                ? percent(el.CAPITALIZATION_RATE)
                                                : 'N/A'
                                            : el.CLOSE_CAP_RATE
                                                ? percent(el.CLOSE_CAP_RATE)
                                                : 'N/A'}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <LinkComp className='stats-more'
                                  to={{pathname: 'list', query: query}}
                        >
                            See More
                        </LinkComp>
                    </div>
                ) : null}
            </div>
        );
    }
}